/* eslint-disable no-shadow */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import CBRScale from './CBRScale';
import useIsMobile from '../../hooks/useIsMobile';
import RatingInfoV5 from '../../InfoPopUps/RatingInfoNew/RatingInfoV5';

import styles from './ratingDisplayV5.scss';

const RatingV5 = (props) => {
	const {
		title,
		titleColor,
		value,
		footer,
		showRatingInfo,
		isVerified,
		showColorBall,
		showGetRatedButton = false,
		onGetRatedClick,
		ratingInfoType = 'ratingInfo',
		gameType,
		'data-testid': dataTestId,
	} = props;
	const wrapperRef = useRef(null);
	const [showInfoPopup, setShowInfoPopup] = useState();

	const { isMobileWidth } = useIsMobile();
	const isUnrated = value === 'Unrated' || !value;
	const [rightAlignInfoPopup, setRightAlignInfoPopup] = useState(true);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (e) => {
		if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
			setShowInfoPopup(false);
		}
	};

	const handleShowInfoPopup = (ev) => {
		ev.stopPropagation();
		ev.preventDefault();

		let right = false;
		if (ev.nativeEvent.clientX > window.innerWidth / 2) {
			right = true;
		}

		setShowInfoPopup(true);
		setRightAlignInfoPopup(right);
	};

	const handleCloseInfoPopup = (e) => {
		e.stopPropagation();
		e.preventDefault();
		setShowInfoPopup(false);
	};

	const getRatingInfo = () => {
		if (showRatingInfo) {
			return (
    <RatingInfoV5
        rootClass={styles.ratingInfoRoot}
        isMobile={isMobileWidth}
        type={ratingInfoType}
        showPopup={showInfoPopup}
        closePopup={handleCloseInfoPopup}
        rightAlign={rightAlignInfoPopup}
				/>
			);
		}
		return null;
	};

	return (
    <div
        className={`${styles.rating} ${styles.showRatingInfo}`}
        ref={wrapperRef}
        onClick={handleShowInfoPopup}
        data-testid={dataTestId}
    >
        <div className={`${styles.title} ${titleColor} noselect`} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>
            {title} {!!gameType && <div className={gameType} />}
            {isVerified && <div className="verified14" />}
        </div>
        {showGetRatedButton && onGetRatedClick ? (
            <div className={styles.value}>
                <div className={styles.btnWrapper}>
                    <button
                        type="button"
                        className={
								'btn btn-white btn-inv btn-sm text-uppercase'
							}
                        onClick={onGetRatedClick}
                        data-testid={dataTestId ? `${dataTestId}.get-rated-btn` : undefined}
                    >
							Get Rated
                    </button>
                </div>
            </div>
			) : (
    <div
        className={`${styles.value} ${
						isUnrated ? styles.unrated : ''
					} noselect`}
        title={value || 'Unrated'}
        data-testid={dataTestId ? `${dataTestId}.value` : undefined}
				>
        {isUnrated ? 'UR' : value}
    </div>
			)}
        <div className={`${styles.footer} noselect`} data-testid={dataTestId ? `${dataTestId}.footer` : undefined}>
            {showColorBall && (
            <div className={styles.pbrScaleWrapper}>
                <CBRScale value={showColorBall} /> {getRatingInfo()}
            </div>
				)}
            {footer && (
            <div className={showColorBall ? 'mt6' : ''}>{footer}</div>
				)}
            {!showColorBall && showRatingInfo && getRatingInfo()}
        </div>
    </div>
	);
};

RatingV5.defaultProps = {
	ratingInfoType: 'ratingInfo',
	footer: '',
	showRatingInfo: false,
	showGetRatedButton: false,
	showColorBall: false,
	gameType: null,
};

RatingV5.propTypes = {
	title: PropTypes.string.isRequired,
	titleColor: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	footer: PropTypes.string,
	showRatingInfo: PropTypes.bool,
	isVerified: PropTypes.bool.isRequired,
	showColorBall: PropTypes.bool,
	showGetRatedButton: PropTypes.bool,
	onGetRatedClick: PropTypes.func,
	ratingInfoType: PropTypes.string,
	gameType: PropTypes.string,
};

export default RatingV5;
